// import 'core-js/es6/map';
// import 'core-js/es6/set';
// import 'core-js/fn/array/find';
// import 'core-js/fn/array/includes';
// import 'core-js/fn/number/is-nan';
import 'core-js';
import React from 'react';
import ReactDOM from 'react-dom';
import { Router, Route, Switch, Redirect, HashRouter } from "react-router-dom";
import './index.css';
import App from './App';
import Dashboard from './Dashboard';

import Signature from './Signature';
import { PDFDownloadLink, Document, Page, PDFViewer } from '@react-pdf/renderer'
import { Button, IconButton } from '@material-ui/core';
import reportWebVitals from './reportWebVitals';
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import ReactDOMServer from "react-dom/server";
import domtoimage from 'dom-to-image';
import Login from './Login';
import PrivateRoute from "./_Services/PrivateRoute";
import { createBrowserHistory, createHashHistory } from "history";
import logger from "redux-logger";
import thunk from "redux-thunk";
import { Provider, useSelector, connect } from "react-redux";
import { createStore, applyMiddleware } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import app_reducers from "./reducers/app";
import { unstable_createMuiStrictModeTheme, makeStyles, ThemeProvider } from '@material-ui/core/styles';
// import { useDispatch, useSelector } from "react-redux";
import { blue, indigo } from '@material-ui/core/colors';
import MyBackdrop from './components/BackDrop/BackDrop';

import UnderConstruction from "./Questionaire/UnderConstruction";
import BackBody from "./Questionaire/BackBody";
import Questionaire66th from './Questionaire/66th';
import Questionaire67th from './Questionaire/67th';
import Questionaire69th from './Questionaire/69th';
import Questionaire68th from './Questionaire/68th';
import Questionaire70th from './Questionaire/70th';
import Questionaire80th from './Questionaire/80th';
import Questionaire81th from './Questionaire/81th';
import Nopaper from './Questionaire/Nopaper';
import { initial } from 'lodash';

import Results from './ShowResult/Record';
import Match from './Match';
import Test from './Test';

import BasicCalendar from './components/Calendar/BasicCalendar';
import WeeklyBooking from './Layouts/WeeklyBooking';
import LaborFormCheck from './Layouts/LaborFormCheck';
import Minmax from './Layouts/Minmax';

import { SnackbarProvider, useSnackbar } from "notistack";
import ClearIcon from "@material-ui/icons/Clear";
import { IntlProvider } from "react-intl";
import ImgList from './components/ImgList/ImgList';


// const domToPdf = require('dom-to-pdf');
// // const puppeteer = require("puppeteer");

// const ToPdf = () => {
//   var element = document.getElementById('jsx-template');
//   var options = {
//     filename: 'test.pdf',
//   };
//   domToPdf(element, options, function () {
//     //上傳
//     alert("問卷完成");
//   });
// }
const history = createBrowserHistory();
const rootReducer = (state = {}, action) => {
  return {
    app: app_reducers(state.app, action)
  };
};
const store = createStore(rootReducer, composeWithDevTools(applyMiddleware(thunk, logger)));  //logger要放在最後

//避免用戶回到上一頁
window.addEventListener("popstate", () => {
  history.go(1);
});


const InitialSetting = () => {
  // const [dark, setDark] = React.useState(true);
  const notistackRef = React.createRef();
  const onClickDismiss = key => () => {
    notistackRef.current.closeSnackbar(key);
  }

  const { dark } = useSelector(state => ({
    dark: state.app.dark,
  }));
  const { app } = useSelector(state => ({
    app: state.app
  }));
  const formLabelsTheme = unstable_createMuiStrictModeTheme({
    overrides: {
      MuiFormLabel: {
        asterisk: {
          // fontSize:"20px",
          color: '#db3131',
          '&$error': {
            color: '#db3131'
          },
        },
        root: {
          color: dark ? "#1a90ff" : "black",
          "&$focused": dark ? { color: "#1a90ff" } : { color: indigo[500] }
        }
      }
    },
    palette: {
      type: dark ? "dark" : "light",
      primary: {
        main: dark ? blue[500] : indigo[500]
      },
      // secondary: {
      //   main: "#FFFFFF"
      // }
    }
  })

  return (
    <ThemeProvider theme={formLabelsTheme}>
      <IntlProvider locale={app.i18n.locale} messages={app.i18n.messages}>
        <SnackbarProvider
          maxSnack={3}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right"
          }}
          ref={notistackRef}
          action={key => (
            <IconButton onClick={onClickDismiss(key)}>
              <ClearIcon />
            </IconButton>
          )}
        >
          <Route exact path={`${process.env.PUBLIC_URL}/Login`} component={Login} />
          <Route exact path={`${process.env.PUBLIC_URL}`} component={Login} />
          {/* <Route path={`${process.env.PUBLIC_URL}/Match`} component={Match} /> */}
          <Route path={`${process.env.PUBLIC_URL}/RoomBooking`} component={BasicCalendar} />
          <Route path={`${process.env.PUBLIC_URL}/LaborFormCheck`} component={LaborFormCheck} />
          <Route path={`${process.env.PUBLIC_URL}/WeeklyBooking`} component={WeeklyBooking} />
          <Route path={`${process.env.PUBLIC_URL}/LINE`} component={Test} />
          <Route path={`${process.env.PUBLIC_URL}/ImgList`} component={ImgList} />
          <PrivateRoute path={`${process.env.PUBLIC_URL}/Admin`} component={Dashboard} />
          {/* <Redirect from={`${process.env.PUBLIC_URL}/Match`} to={`${process.env.PUBLIC_URL}/Match`} />
        <Redirect from={`${process.env.PUBLIC_URL}/*`} to={`${process.env.PUBLIC_URL}/Login`} /> */}
        </SnackbarProvider>
      </IntlProvider>

    </ThemeProvider>

  )
}

ReactDOM.render(

  <>
    <Provider store={store}>
      <Router history={history} basename={`${process.env.PUBLIC_URL}/`}>
        <Switch>
          <InitialSetting />
        </Switch>
      </Router>
    </Provider>
  </>,
  document.getElementById('root')
);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
